import { render, staticRenderFns } from "./card-video-slider.vue?vue&type=template&id=115f70d3&scoped=true&"
import script from "./card-video-slider.vue?vue&type=script&lang=js&"
export * from "./card-video-slider.vue?vue&type=script&lang=js&"
import style0 from "./card-video-slider.vue?vue&type=style&index=0&id=115f70d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115f70d3",
  null
  
)

export default component.exports